export const timeoutFormat = (Vue) => {
    Vue.filter(timeoutFormat, (object) => {
        let date = new Date(object);
        let nowDate = date.getMinutes() + 15;
        console.log(date, nowDate);
        return true;
    })
}


// WEBPACK FOOTER //
// ./src/_filters/timeout.filter.js